var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner-border text-primary",staticStyle:{"width":"1rem","height":"1rem"},attrs:{"role":"status"}},[(_vm.sr)?_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.sr))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }